export const CAI_GENERATION_ENABLE_FLAG = "current_asset_intelligence_customer_enabled";

export function isCaiGenerationEnabled(account) {
  return Boolean(account && String(account.status || "").toLowerCase() === "active"
    && (account[CAI_GENERATION_ENABLE_FLAG] === true
      || account.local_config?.[CAI_GENERATION_ENABLE_FLAG] === true));
}
